<template>
    <div>
        <label class="form-control-wrap">
            {{ label }}
        </label>
        <div class="form-control-wrap">
            <v-number v-model="content" class="form-control" :min="min" :max="max" :step="step" :disabled="disabled" :allow_empty="allow_empty" />
        </div>
        <small class="form-text text-danger">Value is invalid.</small>
    </div>
</template>
<script>
    export default {
        props: ["label", "model", "min", "max", "step", "allow_empty", "disabled"],
        data: function(){
            return {
                content: this.model
            }
        },
        watch: {
            model(val) {
                if (JSON.stringify(this.model) != JSON.stringify(this.content)){
                    this.content = this.model;
                }
            },
            content(val){
                this.$emit('update:model', val);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/layout/number.vue